const GraphQLForm = require('app/graphql/Form');
const ConfirmModal = require('app/ui/modal/Confirm');
const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitSupplier',
            'supplier': {
                'id': '',
                'name': '',
                'address': '',
                'email': '',
                'phone': '',
                'fax': '',
                'freeDelivery': '',
                'penalty': '',
                'billingStatus': '',
                'pricesStatus': '',
                'rfa': '',
                'logo': null,
            },
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.supplier = this.settings.supplier;

        this.createMode = true;
        if(this.supplier.id){
            this.createMode = false;
        }

        this.$form = $('<form/>')
        .addClass('supplier-info-form');

        this.loadData();

        super.initialize();
    }

    getSupplier(){
        return this.supplier;
    }

    getForm(){
        return this.$form;
    }

    refresh(){
        this.loadData();
    }

    loadData(){
        var self = this;

        this.$form.html('');

        let queries = [
        ];

        if(this.supplier.id){
            queries.push(this.buildSupplierQuery());
        }

        if(queries.length <= 0){
            return this.fillForm({});
        }

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSupplierQuery(){
        var self = this;

        let id = this.supplier.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'id',
            'name',
            'address',
            'email',
            'phone',
            'fax',
            'freeDelivery',
            'penalty',
            'billingStatus',
            'pricesStatus',
            'rfa',
            'logo { url }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplier',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    fillForm(data){
        if(data.supplier){
            this.supplier = data.supplier;
        }

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success');

        if(this.supplier.id){
            this.$btnSubmit.append(window.translate('app.supplier.show.tabs.info.infoForm.submit.label'));
        }else{
            this.$btnSubmit.append(window.translate('app.supplier.create.submit.label'));
        }

        this.$form
        .append(
            $('<div/>')
            .append(this.buildForm())
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append(this.$btnSubmit)
            )
        );

        return this.$form;
    }

    getFields(){
        let fields = super.getFields();
        fields.push('supplier { id }');
        return fields;
    }
    
    getVariables(){
        let variables = {};

        if(this.supplier.id){
            variables.supplier = {
                'value': this.supplier.id,
                'type': 'Int'
            }
        }

        return variables;
    }

    buildForm(){
        var self = this;

        let $box = $('<div/>')
        .addClass('white-box');

        //LABEL
        let $label = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.label'))
        .appendTo($box);

        let name = this.supplier.name;
        let address = this.supplier.address;
        let emails = this.supplier.email.split(';');
        let phone = this.supplier.phone;
        let fax = this.supplier.fax;
        let freeDelivery = this.supplier.freeDelivery;
        let penalty = this.supplier.penalty;
        let billingStatus = this.supplier.billingStatus;
        let pricesStatus = this.supplier.pricesStatus;
        let rfa = this.supplier.rfa;

        //FIELD name
        let $nameLabel = $('<label/>')
        .attr('for','name')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.name.label'));
        this.$inputName = $('<input/>')
        .attr('type','text')
        .attr('name','name')
        .addClass('form-control')
        .val(name);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($nameLabel)
            .append(this.$inputName)
        )

        //FIELD address
        let $addressLabel = $('<label/>')
        .attr('for','address')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.address.label'));
        this.$inputAddress = $('<textarea/>')
        .attr('rows',3)
        .attr('name','address')
        .addClass('form-control')
        .append(address);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($addressLabel)
            .append(this.$inputAddress)
        )

        let $emailTemplate = $('<div/>')
        .addClass('mb-2')
        .addClass('supplier-contactform-email-container')
        .append(
            $('<input/>')
            .attr('name','email[]')
            .attr('type','email')
            .addClass('form-control')
        );
        let $emailLabel = $('<label/>')
        .attr('for','email')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.email.label'));
        let $emailContainer = $('<div/>');
        if(emails.length > 0){

            for(var i in emails){
                let email = emails[i];

                let $clone = $emailTemplate.clone();


                let $input = $('input[name="email[]"',$clone);

                $input.val(email);

                $emailContainer.append($clone);
            }
        }else{
            let $clone = $emailTemplate.clone();
            $emailContainer.append($clone);
        }
        let $btnAddEmail = $('<button/>')
        .addClass('btn btn-sm btn-info btn-email-add')
        .append(
            $('<i/>')
            .addClass('fas fa-plus')
        )
        .on('click',function(event){
            event.stopPropagation();
            event.preventDefault();

            let $clone = $emailTemplate.clone();
            $emailContainer.append($clone);
        })
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($emailLabel)
            .append($emailContainer)
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append($btnAddEmail)
            )
        );

        //FIELD phone
        let $phoneLabel = $('<label/>')
        .attr('for','phone')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.phone.label'));
        let $phoneInput = $('<input/>')
        .attr('type','text')
        .attr('name','phone')
        .addClass('form-control')
        .val(phone);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($phoneLabel)
            .append($phoneInput)
        )

        //FIELD fax
        let $faxLabel = $('<label/>')
        .attr('for','fax')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.fax.label'));
        let $faxInput = $('<input/>')
        .attr('type','text')
        .attr('name','fax')
        .addClass('form-control')
        .val(fax);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($faxLabel)
            .append($faxInput)
        )

        //FIELD freeDelivery
        let $freeDeliveryLabel = $('<label/>')
        .attr('for','freeDelivery')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.freeDelivery.label'));
        let $freeDeliveryInput = $('<input/>')
        .attr('type','text')
        .attr('name','freeDelivery')
        .attr('placeholder',"€")
        .addClass('form-control')
        .val(freeDelivery);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($freeDeliveryLabel)
            .append($freeDeliveryInput)
        )


        //FIELD penalty
        let $penaltyLabel = $('<label/>')
        .attr('for','penalty')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.penalty.label'));
        let $penaltyInput = $('<input/>')
        .attr('type','text')
        .attr('name','penalty')
        .attr('placeholder',"€")
        .addClass('form-control')
        .val(penalty);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($penaltyLabel)
            .append($penaltyInput)
        )

        //FIELD billingStatus
        let $billingStatusLabel = $('<label/>')
        .attr('for','billingStatus')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.billingStatus.label'));
        let values = [1,2];
        let $billingStatusContainer = $('<div/>')
        .addClass('row');
        for(var v in values){
            let value = values[v];
            let label = window.translate('app.supplier.show.tabs.info.infoForm.billingStatus.value.'+value);

            let $inputRadio = $('<input/>')
            .attr('id','billingStatus'+value)
            .attr('type','radio')
            .attr('name','billingStatus')
            .val(value);

            if(value == billingStatus){
                $inputRadio.attr('checked','checked');
            }

            let $labelRadio = $('<label/>')
            .attr('for','billingStatus'+value)
            .append(label);

            let $inputContainer = $('<div/>')
            .addClass('col-2')
            .append($inputRadio)
            .append(' ')
            .append($labelRadio);

            $billingStatusContainer.append($inputContainer);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($billingStatusLabel)
            .append($billingStatusContainer)
        );

        //FIELD pricesStatus
        let $pricesStatusLabel = $('<label/>')
        .attr('for','pricesStatus')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.pricesStatus.label'));
        let priceStatusValues = [1,2];
        let $pricesStatusContainer = $('<div/>')
        .addClass('row');
        for(var v in priceStatusValues){
            let value = priceStatusValues[v];
            let label = window.translate('app.supplier.show.tabs.info.infoForm.pricesStatus.value.'+value);

            let $inputRadio = $('<input/>')
            .attr('id','pricesStatus'+value)
            .attr('type','radio')
            .attr('name','pricesStatus')
            .val(value);

            if(value == pricesStatus){
                $inputRadio.attr('checked','checked');
            }

            let $labelRadio = $('<label/>')
            .attr('for','pricesStatus'+value)
            .append(label);

            let $inputContainer = $('<div/>')
            .addClass('col-2')
            .append($inputRadio)
            .append(' ')
            .append($labelRadio);

            $pricesStatusContainer.append($inputContainer);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($pricesStatusLabel)
            .append($pricesStatusContainer)
        );

        //FIELD rfa
        let $rfaLabel = $('<label/>')
        .attr('for','rfa')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.rfa.label'));
        let $rfaInput = $('<input/>')
        .attr('type','text')
        .attr('name','rfa')
        .attr('placeholder',"%")
        .addClass('form-control')
        .val(rfa);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($rfaLabel)
            .append($rfaInput)
        )


        //FIELD logo
        let $logoLabel = $('<label/>')
        .attr('for','logo')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.logo.label'));
        this.$inputLogo = $('<input/>')
        .attr('type','file')
        .attr('accept','image/*')
        .attr('name','logo')
        .addClass('form-control');
        let $logoContainer = $('<div/>')
        .addClass('form-group')
        .append($logoLabel)
        .append(this.$inputLogo);
        if(this.supplier.logo){
            let logoUrl = window.App.get('apiBaseUrl')+this.supplier.logo.url;
            let $logoPreview = $('<img/>')
            .attr('src',logoUrl)
            .addClass('img img-preview');

            let $btnDeleteLogo = $('<button/>')
            .attr('type','button')
            .addClass('btn btn-sm btn-text text-danger ms-2')
            .append(
                $('<i/>')
                .addClass('fas fa-trash me-1')
            )
            .append(window.translate('app.supplier.show.tabs.info.infoForm.logo.delete.label'))
            .on('click',function(){
                self.onClickDeleteLogo();
            });

            let $logoPreviewContainer = 
                $('<div/>')
                .addClass('d-flex justify-content-center mt-1')
                .append($logoPreview)
                .append(' ');

            $logoContainer
            .append($logoPreviewContainer);
            window.uncacheFile(logoUrl,function(){
                $logoPreviewContainer.append($btnDeleteLogo);
            })
        }
        $box.append($logoContainer);

        return $box;
    }

    onClickLogo(){
        var self = this;

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('app.supplier.show.tabs.info.infoForm.logo.delete.confirm'))
        );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event){
                self.proceedLogo(confirmModal)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();
    }

    proceedLogo(confirmModal){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'supplier': {
                'value': this.supplier.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteSupplierLogo",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                confirmModal.dispose();
                window.notify(data.message,'success');
                self.refresh();
            },
            'error': function(message, xhr){
                confirmModal.dispose();
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }


    onClickDeleteLogo(){
        var self = this;

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('app.supplier.show.tabs.info.infoForm.logo.delete.confirm'))
        );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event){
                self.proceedDeleteLogo(confirmModal)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();
    }

    proceedDeleteLogo(confirmModal){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'supplier': {
                'value': this.supplier.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteSupplierLogo",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                confirmModal.dispose();
                window.notify(data.message,'success');
                self.refresh();
            },
            'error': function(message, xhr){
                confirmModal.dispose();
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }
}

module.exports = Form;

